import BusinessEnquire from './BusinessEnquire.page';

export default BusinessEnquire;
